import Vue from 'vue'
import request from '@/helpers/request'
import snack from '@/helpers/snack'
import router from '@/router'

export default {
  GET_GOOD_GROUPS: ({ commit, state }, payload) => {
    return request(
      'GET',
      `${Vue.config.server}/${Vue.config.modules.crm.api.goodGroups.all}`,
      {
        params: payload.params,
      },
      true,
    )
      .then(response => {
        if (response.data.result === 'success') {
          const data = response.data.data
          commit('appendLoadedGoodGroups', data.items)
          commit('setGoodGroupFilters', data.filters)
          return data.count
        } else {
          // TODO: Show error dialog
        }
      })
      .finally(() => {
        commit('setLoad', false)
      })
  },
  GET_GOOD_GROUP: ({ commit, state }, payload) => {
    return request(
      'GET',
      `${Vue.config.server}/${Vue.config.modules.crm.api.goodGroups.one.replace('$1', payload.id)}`,
      {
        params: payload.params,
      },
      true,
    ).then(response => {
      if (response.data.result === 'success') {
        const data = response.data.data
        commit('setGoodGroup', data)
        commit('setLoad', false)
      } else {
        // TODO: Show error dialog
      }
    })
  },
  CREATE_GOOD_GROUP: ({ commit, state }, payload) => {
    commit('setLoad', true)

    return request(
      'POST',
      `${Vue.config.server}/${Vue.config.modules.crm.api.goodGroups.all}`,
      {
        title: payload.title,
      },
      true,
    )
      .then(response => {
        if (response.data.result === 'success') {
          commit('addGoodGroup', response.data.data)
          snack.add(Vue.config.localization.ru.savedMessage, 'primary')
        } else {
          snack.add(Vue.config.localization.ru.errorSavingMessage)
        }
        return response
      })
      .finally(() => {
        commit('setLoad', false)
      })
  },
  UPDATE_GOOD_GROUP: ({ commit, state }, payload) => {
    return new Promise((resolve, reject) => {
      commit('setLoad', true)

      request(
        'PUT',
        `${Vue.config.server}/${Vue.config.modules.crm.api.goodGroups.one.replace('$1', payload.id)}`,
        {
          title: payload.title,
        },
        true,
      ).then(response => {
        if (response.data.result === 'success') {
          commit('changeGoodGroup', response.data.data)

          snack.add(Vue.config.localization.ru.savedMessage, 'primary')
        } else {
          snack.add(Vue.config.localization.ru.errorSavingMessage)
        }
      })

      commit('setLoad', false)
      resolve()
    })
  },
  DELETE_GOOD_GROUP: ({ commit, state }, payload) => {
    return new Promise((resolve, reject) => {
      commit('setLoad', true)

      request(
        'DELETE',
        `${Vue.config.server}/${Vue.config.modules.crm.api.goodGroups.one.replace('$1', payload.id)}`,
        {},
        true,
      ).then(response => {
        if (response.data.result === 'success') {
          commit('removeGoodGroup', payload.id)
          const groupsLength = state.goodGroups.length

          if (groupsLength > 0) {
            commit('setGoodGroup', state.goodGroups[0])
            commit('setLoad', false)

            router.push({ path: Vue.config.modules.crm.route.goodGroups.one.replace('$1', state.goodGroups[0].id) })
          } else {
            router.push({ path: Vue.config.modules.crm.route.goodGroups.all })
          }

          snack.add(Vue.config.localization.ru.successRemove, 'primary')
        } else {
          snack.add(Vue.config.localization.ru.errors.removing)
        }
      })

      commit('setLoad', false)
      resolve()
    })
  },
}
